import React, { Component, Fragment } from 'react';
import { history } from 'components/App/components/UnauthenticatedApp';
import './Tip.module.scss';

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Tip extends Component {

    render() {

        const { tip } = this.props;

        return (
            <div styleName='tipBackground' >
                <FontAwesomeIcon onClick={this.props.close} icon={[ 'far','times' ]} styleName='icon'/>
                <div styleName="tip">
                    <h2>Tip:</h2>
                    <img styleName='image' src={`/images/tips/${tip.image}`}></img>
                    <p>{tip.text} </p>
                </div>
                <div styleName='link-wrapper' onClick={() => history.push('/tips')}>
                    <p styleName='more-tips'>Meer tips</p>
                </div>
            </div>
        );
    }

}

export default Tip;